import React from 'react';
import { useSelector } from 'react-redux';
import { FaMapMarkerAlt, FaClock, FaPhone, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const { profile } = useSelector((state) => state.profile);

  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    return new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const handleWhatsApp = () => {
    if (profile?.whatsapp) {
      const message = `Hello! I would like to place an order at ${profile.name}.`;
      const url = `https://wa.me/${profile.whatsapp}?text=${encodeURIComponent(message)}`;
      window.open(url, '_blank');
    }
  };

  const handleCall = () => {
    if (profile?.mobile) {
      window.open(`tel:${profile.mobile}`, '_blank');
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-200 via-gray-100 to-gray-200 text-gray-800 pb-20 md:pb-0">
      <div className="max-w-screen-xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Restaurant Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              {profile?.DocLogo?.imageUrl && (
                <img 
                  src={profile.DocLogo.imageUrl} 
                  alt={profile?.name || 'Restaurant Logo'} 
                  className="w-12 h-12 object-contain rounded-lg mr-4"
                />
              )}
              <h3 className="text-2xl font-bold poppins text-gray-800">
                {profile?.name || 'Restaurant Name'}
              </h3>
            </div>
            <p className="text-gray-600 text-lg leading-relaxed mb-4">
              {profile?.description}
            </p>
            <div className="flex items-center text-gray-700 mb-2">
              <FaMapMarkerAlt className="w-5 h-5 mr-3 text-primary" />
              <span className="poppins">{profile?.address || 'Address not available'}</span>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h4 className="text-xl font-semibold poppins mb-4 text-gray-800">Opening Hours</h4>
            <div className="space-y-2">
              <div className="flex items-center text-gray-700">
                <FaClock className="w-4 h-4 mr-3 text-primary" />
                <span className="poppins">
                  {formatTime(profile?.from_time)} - {formatTime(profile?.to_time)}
                </span>
              </div>
              <p className="text-sm text-gray-600 poppins ml-7">
                Open daily for your convenience
              </p>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-semibold poppins mb-4 text-gray-800">Contact Us</h4>
            <div className="space-y-3">
              <button 
                onClick={handleCall}
                className="flex items-center text-gray-700 hover:text-gray-900 transition-colors duration-200 group"
              >
                <FaPhone className="w-4 h-4 mr-3 text-primary group-hover:scale-110 transition-transform duration-200 transform rotate-90" />
                <span className="poppins">{profile?.mobile || 'Phone not available'}</span>
              </button>
              <button 
                onClick={handleWhatsApp}
                className="flex items-center text-gray-700 hover:text-gray-900 transition-colors duration-200 group"
              >
                <FaWhatsapp className="w-4 h-4 mr-3 text-green-500 group-hover:scale-110 transition-transform duration-200" />
                <span className="poppins">WhatsApp</span>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-300 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 poppins text-sm">
              © Yoro Technologies. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <span className="text-gray-600 poppins text-sm">Privacy Policy</span>
              <span className="text-gray-600 poppins text-sm">Terms of Service</span>
              <button 
                onClick={() => {
                  const message = "Hello 👋,\nI came across your website and I'm interested in knowing more about your Digital Menu.\nCould you please share the details, pricing, and how it works?\n\nThank you 🙏";
                  const url = `https://wa.me/919207600660?text=${encodeURIComponent(message)}`;
                  window.open(url, '_blank');
                }}
                className="text-gray-600 poppins text-sm hover:text-gray-900 transition-colors duration-200 cursor-pointer"
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
